import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  AlertTitle,
  Alert,
  Snackbar,
  Radio,
  Skeleton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
// import masterCardImg from "../../assets/mastercard.png";
import visaImg from "../../assets/cards/visa.png";
import amexImg from "../../assets/cards/amex.png";
import dinersImg from "../../assets/cards/diners.jpg";
import discoverImg from "../../assets/cards/discover.jpg";
import jcbImg from "../../assets/cards/jcb.jpg";
import cartesImg from "../../assets/cards/cartes_bancaires.png";
import unionpayImg from "../../assets/cards/union.png";
import masterImg from "../../assets/cards/master.png";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import { PiCreditCard } from "react-icons/pi";
import { GrCreditCard } from "react-icons/gr";
import { IoIosWarning } from "react-icons/io";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { useTheme } from "../../style/theme";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import axios from "axios";
import loader from "../../assets/loader.gif";

const PaymentMethods = () => {
  const [loading, setLoading] = useState(true);
  const { mode } = useTheme();
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  const [name, setName] = useState(null);
  const [address, setAddress] = useState("");
  const [removeOpen, setRemoveOpen] = useState(false);
  const [fixOpen, setFixOpen] = useState(false);
  const [showAddCard, setShowAddCard] = useState(false);
  const [CardImage, setCardImage] = useState("");
  const [paymentMethods, setPaymentMethods] = useState([]);

  const [showMessage, setShowMessage] = useState({
    show: true,
    message: "",
    severity: "",
  });
  const [selectedDefaultId, setSelectedDefaultId] = useState("");

  const [clientSecret, setClientSecret] = useState(null);
  const stripe = useStripe();
  const elements = useElements();

  const handleSetDefault = async (id) => {
    try {
      const res = await axios.patch(`/store/payment-method/default/${id}`);
      if (res.data.success) {
        setSelectedDefaultId(id);
        fetchPaymentMethods();
      }
    } catch (error) {
      console.error("Failed to update default method:", error);
    }
  };

  const fetchPaymentMethods = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/store/payment-method");
      const methods = response.data.methods || [];
      setPaymentMethods(methods);

      if (methods.length > 0) {
        const defaultMethod = methods.find((m) => m.isDefault);
        setSelectedDefaultId(defaultMethod?._id || "");
      }
    } catch (error) {
      console.error("Error fetching Payment methods:", error);
    } finally {
      setLoading(false); // Always set to false regardless of success or error
    }
  };

  const handleRemoveConfirm = async () => {
    try {
      await axios.delete(`/store/payment-method/delete/${selectedMethod._id}`);
      // Optionally refresh the list
      setShowMessage({
        show: true,
        message: "Card removed successfully!",
        severity: "success",
      });
      fetchPaymentMethods();
      setRemoveOpen(false);
      setSelectedMethod(null);
    } catch (err) {
      console.error("Failed to remove payment method:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  useEffect(() => {
    if (!showAddCard) return;

    const fetchIntent = async () => {
      try {
        const response = await axios.get(
          "/store/payment-method/create-setup-intent"
        );

        setClientSecret(response?.data?.clientSecret);
      } catch (error) {
        console.error("Error fetching Payment intent:", error);
      }
    };

    fetchIntent();
  }, [showAddCard]);

  async function onSubmit() {
    setLoading(true);
    if (!stripe || !elements || !clientSecret) return;

    const cardNumberElement = elements.getElement(CardNumberElement);
    const expiryElement = elements.getElement(CardExpiryElement);
    const cvcElement = elements.getElement(CardCvcElement);

    const cardComplete = cardNumberElement._complete;
    const expiryComplete = expiryElement._complete;
    const cvcComplete = cvcElement._complete;
    console.log(name, "NAMEEEEEEEEEE");

    if (!name || !cardComplete || !expiryComplete || !cvcComplete) {
      setShowMessage({
        show: true,
        message: "Please complete all card details and enter your name.",
        severity: "warning",
      });
      setLoading(false);
      return;
    }
    const cardElement = elements.getElement(CardNumberElement);
    const result = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          name: name,
        },
      },
    });
    if (result.error) {
      setShowMessage({
        show: true,
        message: "Error adding card",
        severity: "error",
      });
      setLoading(false);
    } else {
      try {
        await axios.post("/store/payment-method", {
          paymentMethodId: result?.setupIntent?.payment_method,
        });
        setShowMessage({
          show: true,
          message: "Card saved successfully!",
          severity: "success",
        });
        setLoading(false);
        fetchPaymentMethods();
        setShowAddCard(false);
        setName("");
      } catch (e) {
        setShowMessage({
          show: true,
          message: "Error adding card",
          severity: "error",
        });
        setLoading(false);
      }
    }
  }

  const cardStyle = {
    style: {
      base: {
        color: mode === "light" ? "#000" : "#ffffff",
        fontSize: "16px",
        fontFamily: "Arial, sans-serif",
        iconColor: "#cccccc",
        "::placeholder": {
          color: "#a5a5a5",
        },
        backgroundColor: "transparent",

        padding: "12px 16px",
        height: "56px",
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
    placeholder: "4200 4525 4242 4254",
  };

  const ExpireStyle = {
    style: {
      base: {
        color: mode === "light" ? "#000" : "#ffffff",
        fontSize: "16px",
        iconColor: "#cccccc",
        "::placeholder": {
          color: "#a5a5a5",
        },
        backgroundColor: "transparent",
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };
  const CVCStyle = {
    style: {
      base: {
        color: mode === "light" ? "#000" : "#ffffff",
        fontSize: "16px",
        iconColor: "#cccccc",
        "::placeholder": {
          color: "#a5a5a5",
        },
        // backgroundColor: "#1e1e1e",
        // padding: "12px 16px", // yahan padding input ke andar ka hota hai
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
    placeholder: "CVV",
  };

  const handleRemoveClose = () => setRemoveOpen(false);
  const handleFixOpen = () => setFixOpen(true);
  const handleFixClose = () => {
    setFixOpen(false);
    setIsEditingName(false);
    setIsEditingAddress(false);
  };

  const handleAddOpen = () => {
    setShowAddCard(true);
  };
  const handleClose = (event) => {
    setShowMessage({ show: false, message: " ", severity: "" });
  };
  const handleRemoveOpen = (method) => {
    setSelectedMethod(method);
    setRemoveOpen(true);
  };

  function checkIfExpired(month, year) {
    const now = new Date();
    const exp = new Date(year, month - 1, 1);
    return exp < now;
  }

  function getCardBrandImage(brand) {
    switch (brand.toLowerCase()) {
      case "visa":
      case "eftpos":
        return visaImg;
      case "amex":
        return amexImg;
      case "diners":
        return dinersImg;
      case "discover":
        return discoverImg;
      case "jcb":
        return jcbImg;
      case "cartes_bancaires":
        return cartesImg;
      case "unionpay":
        return unionpayImg;
      case "mastercard":
        return masterImg;
      default:
        return visaImg;
    }
  }

  function capitalize(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  return (
    <Box sx={{ padding: "20px", minHeight: "100vh" }}>
      <Snackbar
        open={showMessage.show}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert
          severity={showMessage.severity}
          variant="filled"
          sx={{ width: "100%" }}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <AlertTitle> {showMessage.severity}</AlertTitle>
          {showMessage.message}
        </Alert>
      </Snackbar>
      {showAddCard ? (
        <Box sx={{ mt: 4 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <span style={{ color: "#A5A5A5" }}>
              <PiCreditCard size={28} /> {/* Size can be 24, 28, etc. */}
            </span>

            <Typography variant="h6" color="#A5A5A5" gutterBottom>
              Add credit or debit card
            </Typography>
          </Box>
          <Grid container spacing={2} alignItems="flex-end" sx={{ mt: 2 }}>
            {/* form */}
            <Grid container spacing={2}>
              {/* Credit Card Number Label */}
              <Grid item xs={4}>
                <Typography
                  variant="h6"
                  style={{
                    color: "#A5A5A5",
                    fontSize: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Credit Card Number
                </Typography>

                {/* <div className="relative"> */}

                {/* Card Input */}
                {/* <div className=""> */}
                <div
                  style={{
                    border: "2px solid #3C3C3C",
                    borderRadius: "5px",
                    padding: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <div
                    className="flex-1"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <GrCreditCard size={20} />
                  </div>

                  <div
                    className="flex-1"
                    style={{ display: "flex", flexGrow: 1 }}
                  >
                    <div style={{ width: "100%" }}>
                      <CardNumberElement options={cardStyle} />
                    </div>
                  </div>
                </div>
                {/* </div> */}
                {/* </div> */}
              </Grid>

              {/* Expiration Date */}
              <Grid item xs={2.5}>
                <Typography
                  variant="h6"
                  style={{
                    color: "#A5A5A5",
                    fontSize: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Expiration Date
                </Typography>
                <div
                  style={{
                    border: "2px solid #3C3C3C",
                    borderRadius: "5px",
                    padding: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <CardExpiryElement options={ExpireStyle} />
                  </div>
                </div>
              </Grid>
              {/* CVC */}
              <Grid item xs={2.5}>
                <Typography
                  variant="h6"
                  style={{
                    color: "#A5A5A5",
                    fontSize: "15px",
                    marginBottom: "10px",
                  }}
                >
                  CVC
                </Typography>
                <div
                  style={{
                    border: "2px solid #3C3C3C",
                    borderRadius: "5px",
                    padding: "20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <CardCvcElement options={CVCStyle} />
                  </div>
                </div>
              </Grid>
              {/* NAME */}
              <Grid item xs={4}>
                <Typography
                  variant="h6"
                  style={{
                    color: "#A5A5A5",
                    fontSize: "15px",
                    marginBottom: "10px",
                  }}
                >
                  Name on Card
                </Typography>
                <TextField
                  fullWidth
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />{" "}
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12}>
              <Typography variant="body2" sx={{ color: "#aaa" }}>
                By continuing you agree to the Clikkle store{" "}
                <span style={{ color: "#0080FF", cursor: "pointer" }}>
                  Terms of Service
                </span>
                . The{" "}
                <span style={{ color: "#0080FF", cursor: "pointer" }}>
                  Privacy Notice
                </span>{" "}
                describes how your data is handled.
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                  variant="contained"
                  sx={{ px: 6, color: "#fff", backgroundColor: "#0080FF" }}
                  onClick={() => onSubmit()}
                >
                  {loading ? (
                    <img src={loader} width={18} height={18} alt="Loading..." />
                  ) : (
                    "Save"
                  )}
                </Button>
                <Button
                  onClick={() => setShowAddCard(false)}
                  sx={{ color: "0080FF" }}
                >
                  Cancel
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Grid container spacing={3}>
          {/* Show Skeletons if loading */}
          {loading
            ? Array.from({ length: 3 }).map((_, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card
                    variant="outlined"
                    sx={{
                      height: "100%",
                      borderStyle: "dashed",
                      borderColor: "#1F1F1F",
                      backgroundColor: mode === "light" ? "#fff" : "#141414",
                      color: "#90caf9",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CardContent sx={{ width: "100%" }}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <Skeleton variant="circular" width={24} height={24} />
                        <Box
                          sx={{
                            border: 2,
                            borderColor: "gray",
                            padding: "10px 20px",
                            borderRadius: "10px",
                            width: { xs: 100, sm: 140 },
                          }}
                        >
                          <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={40}
                          />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <Skeleton variant="text" width="80%" height={24} />
                          <Skeleton variant="text" width="60%" height={20} />
                          <Skeleton variant="text" width="40%" height={20} />
                          <Skeleton variant="text" width="30%" height={20} />
                        </Box>
                      </Box>
                      <Divider
                        sx={{ my: 2, borderColor: "#1F1F1F", width: "100%" }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: 1,
                        }}
                      >
                        <Skeleton
                          variant="rectangular"
                          width={60}
                          height={30}
                        />
                        <Skeleton
                          variant="rectangular"
                          width={60}
                          height={30}
                        />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))
            : paymentMethods.map((method, index) => {
                const isExpired = checkIfExpired(
                  method.expMonth,
                  method.expYear
                );

                return (
                  <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
                    <Card
                      variant="outlined"
                      sx={{
                        height: "100%",
                        borderStyle: "dashed",
                        borderColor: "#1F1F1F",
                        backgroundColor: mode === "light" ? "#fff" : "#141414",
                        color: "#90caf9",
                        // display: "flex",
                        // alignItems: "center",
                        // justifyContent: "center",
                        "&:hover": {
                          borderColor: "#90caf9",
                        },
                      }}
                    >
                      <CardContent>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            justifyContent: "space-between",
                            width: "100%",
                            height: "110px",
                            paddingRight: "8px",
                          }}
                        >
                          <Radio
                            checked={selectedDefaultId === method._id}
                            onChange={() => handleSetDefault(method._id)}
                            value={method._id}
                            sx={{
                              color: mode === "light" ? "gray" : "#fff",
                              cursor: "pointer",
                            }}
                          />
                          <Box
                            sx={{
                              border: 2,
                              borderColor: "#1F1F1F",
                              padding: "2px 15px",
                              borderRadius: "10px",
                              width: { xs: 100, sm: 140 },
                            }}
                          >
                            <img
                              src={getCardBrandImage(method.brand)}
                              alt={method.brand}
                              style={{ width: "100%", height: "50px" }}
                            />
                          </Box>
                          <Box>
                            <Typography
                              variant="subtitle1"
                              sx={{
                                fontSize: { xs: "1rem", sm: "1.2rem" },
                                color: mode === "light" ? "#000" : "#fff",
                              }}
                            >
                              {capitalize(method.brand)} •••• {method.last4}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#aaa" }}>
                              Expires {String(method.expMonth).padStart(2, "0")}
                              /{method.expYear}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#aaa" }}>
                              {method.name}
                            </Typography>
                            {isExpired && (
                              <Typography
                                variant="body2"
                                sx={{
                                  paddingTop: { xs: "10px", sm: "15px" },
                                  color: "#FF5353",
                                  display: "flex",
                                  justifyContent: "start",
                                  gap: 1,
                                }}
                              >
                                <IoIosWarning size={18} /> Expired
                              </Typography>
                            )}
                            {method.isDefault && (
                              <Typography
                                variant="caption"
                                sx={{ color: "#00B894", mt: 1 }}
                              >
                                Default Method
                              </Typography>
                            )}
                          </Box>
                        </Box>
                        <Divider
                          sx={{ my: 2, borderColor: "#1F1F1F", width: "100%" }}
                        />
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 1,
                          }}
                        >
                          <Button
                            size="small"
                            sx={{ color: "#0080FF", bgcolor: "transparent" }}
                            onClick={() => handleRemoveOpen(method)}
                          >
                            Remove
                          </Button>
                          {isExpired && (
                            <Button
                              size="small"
                              sx={{ color: "#143BAD" }}
                              onClick={() => {
                                handleFixOpen(method);
                                setCardImage(method.brand);
                              }}
                            >
                              Fix
                            </Button>
                          )}
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}

          {/* Add Payment Method Card */}
          {loading ? (
            ""
          ) : (
            <Grid item xs={12} sm={6} md={4}>
              <Card
                variant="outlined"
                onClick={handleAddOpen}
                sx={{
                  height: "100%",
                  borderStyle: "dashed",
                  borderColor: "#1F1F1F",
                  backgroundColor: mode === "light" ? "#fff" : "#141414",
                  color: "#90caf9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  "&:hover": {
                    borderColor: "#90caf9",
                  },
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      color: mode === "light" ? "#000" : "#0080FF",
                      display: "flex",
                      height: "150px",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                    }}
                  >
                    <AddIcon />
                    <Typography>Add Payment Method</Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>
      )}

      {/* Remove Confirmation Modal */}
      <Dialog open={removeOpen} onClose={handleRemoveClose}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Remove payment method?
          <IconButton onClick={handleRemoveClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2">
            Removing it means you won’t be able to use this payment method for
            other Clikkle products and services without adding it again.
          </Typography>
          {selectedMethod && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, py: 3 }}>
              <img
                src={getCardBrandImage(selectedMethod.brand)}
                alt={selectedMethod.brand}
                width={30}
                height={23}
              />
              <Typography variant="subtitle1">
                {capitalize(selectedMethod.brand)} •••• {selectedMethod.last4}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRemoveClose} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleRemoveConfirm}
            sx={{ bgcolor: "#0080FF", color: "white" }}
          >
            Remove
          </Button>
        </DialogActions>
      </Dialog>

      {/* Fix (Update) Payment Method Modal */}
      <Dialog open={fixOpen} onClose={handleFixClose} maxWidth="xs" fullWidth>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Update your payment method
          <IconButton onClick={handleFixClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <img
              src={getCardBrandImage(CardImage)}
              alt="mastercard"
              width={30}
              height={22}
            />
            <Box
              sx={{
                display: { xs: "block", sm: "flex" },
                flexDirection: { sm: "row" },
              }}
            >
              <Typography variant="subtitle1">Mastercard •••• 0508</Typography>
              <Typography variant="body2" color="error" sx={{ ml: 1 }}>
                Update your expiration date
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex", alignItems: "flex-end", gap: 2, mb: 2 }}>
            <Typography variant="h5" sx={{ color: "#A5A5A5", lineHeight: 2.5 }}>
              #
            </Typography>

            <TextField
              label="MM"
              size="small"
              variant="standard"
              sx={{
                width: "40px",
                "& .MuiInput-underline:before": {
                  borderBottom: "1px solid #FFFF", // Adjust border thickness
                },
                "& .MuiInput-underline:hover:before": {
                  borderBottom: "1px solid #FFFF",
                },
                "& .MuiInput-underline:after": {
                  borderBottom: "1px solid #FFFF",
                },
              }}
            />

            <TextField
              label="YY"
              size="small"
              variant="standard"
              sx={{
                width: "40px",
                "& .MuiInput-underline:before": {
                  borderBottom: "1px solid #FFFF",
                },
                "& .MuiInput-underline:hover:before": {
                  borderBottom: "1px solid #FFFF",
                },
                "& .MuiInput-underline:after": {
                  borderBottom: "1px solid #FFFF",
                },
              }}
            />

            <TextField
              label="CVC"
              size="small"
              variant="standard"
              sx={{
                width: "40px",
                "& .MuiInput-underline:before": {
                  borderBottom: "1px solid #FFFF",
                },
                "& .MuiInput-underline:hover:before": {
                  borderBottom: "1px solid #FFFF",
                },
                "& .MuiInput-underline:after": {
                  borderBottom: "1px solid #FFFF",
                },
              }}
            />
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <PersonIcon />
            {isEditingName ? (
              <TextField
                value={name}
                onChange={(e) => setName(e.target.value)}
                size="small"
                fullWidth
              />
            ) : (
              <Typography variant="body2">{name}</Typography>
            )}
            <IconButton
              size="small"
              onClick={() => setIsEditingName(!isEditingName)}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <LocationOnIcon />
            {isEditingAddress ? (
              <TextField
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                size="small"
                fullWidth
              />
            ) : (
              <Typography variant="body2">{address}</Typography>
            )}
            <IconButton
              size="small"
              onClick={() => setIsEditingAddress(!isEditingAddress)}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "end",
            }}
          >
            <Box sx={{ width: "8%", textAlign: "start" }}>
              <BorderColorIcon sx={{ width: "70%" }} />
            </Box>

            <Box
              sx={{
                width: "92%",
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                flexDirection: "column",
              }}
            >
              <TextField
                label="Card nickname (Optional)"
                fullWidth
                size="small"
                variant="standard"
                sx={{ height: "26px" }}
                InputProps={{
                  disableUnderline: true,
                }}
              />
              <Divider sx={{ borderColor: "#1F1F1F", width: "100%" }} />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleFixClose}
            color="inherit"
            sx={{ color: "#0080FF" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleFixClose}
            variant="contained"
            sx={{ backgroundColor: "#0080FF", padding: "5px 30px" }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PaymentMethods;
